import clsx from 'clsx';
import { FC, HTMLAttributes, PropsWithChildren } from 'react';
import { Background, Illustration } from '../components/decoration/Illustrations';
import { Logo } from '../components/decoration/Logo';

export const DecorativeSplit: FC<PropsWithChildren<HTMLAttributes<HTMLDivElement>>> = ({
  className,
  children,
  ...props
}) => {
  return (
    <div className={clsx('flex h-screen overflow-hidden')}>
      <div className="hidden h-full min-h-[32rem] w-full flex-col justify-between bg-gradient-to-br from-slate-50 to-gray-100 md:flex md:max-w-[16rem] lg:max-w-sm">
        <div className="z-20 my-12 mx-auto flex items-center justify-center">
          <Logo className="md:w-48 lg:w-64" />
        </div>
        <div className="relative w-full antialiased">
          <div className="absolute bottom-24 z-0 w-full overflow-clip">
            <Background />
          </div>
          <div className="absolute bottom-0 z-10 w-full md:-left-32 lg:left-0">
            <Illustration />
          </div>
        </div>
      </div>
      <div className="flex h-full flex-1 justify-center overflow-y-auto">
        <div {...props} className={clsx('mx-auto w-full max-w-5xl px-6 md:px-12', className)}>
          {children}
        </div>
      </div>
    </div>
  );
};
